// src/i18n/useSyncUserLanguage.js
import { useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { setAppLanguage } from './index';

/**
 * Once the authenticated user's profile hydrates, apply their saved
 * `language` preference (or `locale`) to i18next.
 *
 * - If the profile has a language field, it wins over the localStorage /
 *   browser detection that ran at bootstrap.
 * - If the field is missing, we leave whatever was detected in place.
 * - If the user signs out, we don't force-reset — the localStorage value
 *   from their last session persists, which is friendlier than snapping
 *   back to English on every logout.
 */
export default function useSyncUserLanguage() {
  const { userProfile } = useAuth();
  const lang = userProfile?.language || userProfile?.locale;

  useEffect(() => {
    if (!lang) return;
    setAppLanguage(lang);
  }, [lang]);
}
